import styled from 'styled-components';
import { Colors } from 'src/utils/color';
import { Size } from 'src/shared/text';

export const Container = styled.div`
  padding: 30px;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: ${Size.Large};
  margin-bottom: 20px;
`;

export const UploadInput = styled.input`
  margin: 20px 0;
`;

export const UploadButton = styled.button`
  background-color: ${Colors.theme.primary};
  border: none;
  color: white;
  padding: 10px 20px;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
`;

export const StatusMessage = styled.div`
  margin-top: 20px;
  color: ${Colors.extra.black};
`;